// Lodash
import { get } from 'lodash';

// STORE ACTION AND STATE
import { Actions, ActionTypes } from './actions';
import { initialState, ScheduleState } from './state';
import { Actions as AuthActions, ActionTypes as AuthActionTypes } from '../../auth/store/actions';


/**
 * This effect is for listen Schedule actions, execute Schedule service call and dispatch in Schedule reducer.
 * For Schedule api call purpose.
 *
 * @author Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 01-05-2020(Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>)  created Schedule effect
 */
export function reducer(state = initialState, action: Actions | AuthActions): ScheduleState {
  switch (action.type) {
    // Schedule COMMON METHOD
    case ActionTypes.SCHEDULE_COMMON: {
      return state;
    }
    // Schedule Success COMMON METHOD
    case ActionTypes.SCHEDULE_COMMON_SUCCESS: {
      // commonly store and handle all Schedule modules
      return {
        ...state,
        [action.response.common.STATE]: get(action.response.data, action.response.common.API_RESPONSE),
      };

    }

    // CLEAR_REDUCER METHOD ON LOGOUT
    case AuthActionTypes.CLEAR_REDUCER: {
      return initialState;
    }
    // CLEAR_BUSINESS_REDUCER METHOD ON BUSINESS CHANGE
    case AuthActionTypes.CLEAR_BUSINESS_REDUCER: {
      return initialState;
    }


    // DEFAULT
    default:
      return state;
  }
}
